import React from 'react';

import {AccordionContext} from '../Accordion';
import {AccordionHeaderContext} from '../AccordionHeader';
import {AccordionItemContext} from '../AccordionItem';
import type {AccordionButtonProps} from './_types';

/**
 * The button that toggles the expand/collapse state of the accordion item. In most
 * cases, AccordionButton should be wrapped in an element with role heading.
 */
export const useAccordionButtonState = ({
  id: idProp,
  isDisabled,
  onClick: onClickProp,
}: AccordionButtonProps) => {
  const {density, id, openPanels, size, togglePanel} =
    React.useContext(AccordionContext);
  // @ts-expect-error - TS2339 - Property 'setButtonId' does not exist on type '{ index: number; }'. | TS2339 - Property 'panelId' does not exist on type '{ index: number; }'.
  const {index, setButtonId, panelId} = React.useContext(AccordionItemContext);

  const {adornmentWidth} = React.useContext(AccordionHeaderContext);

  // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'never'.
  const isOpen = openPanels.includes(index);
  const buttonId = idProp || `${id}-button-${index}`;

  React.useEffect(() => {
    setButtonId(buttonId);
  }, [buttonId, setButtonId]);

  const onClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      togglePanel?.(index);
      onClickProp?.(event);
    },
    [index, onClickProp, togglePanel]
  );

  const textMarginStyle = React.useMemo(
    () => ({marginRight: adornmentWidth}),
    [adornmentWidth]
  );

  const memoizedReturn = React.useMemo(
    () => ({
      'aria-controls': panelId,
      'aria-expanded': isOpen,
      density,
      id: buttonId,
      isDisabled,
      isOpen,
      onClick,
      size,
      textMarginStyle,
    }),
    [
      buttonId,
      density,
      isDisabled,
      isOpen,
      onClick,
      panelId,
      size,
      textMarginStyle,
    ]
  );

  return memoizedReturn;
};
